import React from "react";
import ErrorWrapper from "./ErrorWrapper";

function Error() {
  return (
    <>
      <ErrorWrapper />
    </>
  );
}

export default Error;
